import { Analytics } from "@/components/Analytics/Analytics";
import { Outlet } from "react-router-dom";
import "@/utils/validators";
import "@/app/globals.css";
import { Loader } from "./Loader";

export function Root() {
  return (
    <>
      <Loader />
      <Analytics />
      <Outlet />
    </>
  );
}

export default Root;
